function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "101.999998%",
  y2: "100.999999%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#523ED6",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#725DFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "101.999998%",
  y1: "100.999999%",
  x2: "0%",
  y2: "0%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#725DFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#523ED6",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "lines",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.968973551,456.909436 C28.1379873,456.909436 73.1730564,330.416897 176.110357,263.948174 C279.047658,197.485883 324.082727,381.706 405.576901,394.647269 C487.071075,407.601402 553.549271,223.214051 611.451502,208.201665 C669.353734,193.195711 695.088059,266.096476 757.281489,259.664434 C819.468486,253.232392 905.253859,0.234448429 1018.90951,0.234448429 C1132.57159,0.234448429 1224.78411,392.428215 1312.71186,394.647269 C1400.63962,396.879188 1417.18036,206.059795 1467.88341,206.059795",
  id: "Stroke-28",
  stroke: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.968973551,66.6999553 C75.3218725,66.6999553 64.5970925,199.630969 161.100812,201.772839 C257.604531,203.914709 255.462149,390.283129 306.930799,394.650485 C358.399449,399.024274 397.000937,208.204881 478.488678,203.914709 C559.982852,199.630969 564.274051,388.289196 626.461047,394.72767 C688.654478,401.166144 688.654478,323.981639 738.289557,326.123509 C793.849966,328.529092 805.057264,465.197123 858.069974,456.912653 C926.696986,446.190438 943.855347,131.020376 1003.89996,133.162246 C1063.94458,135.310548 1073.59495,325.05579 1119.70442,326.123509 C1194.75215,327.873024 1287.42789,74.9715614 1357.74693,66.6999553 C1412.43237,60.2679132 1427.8987,139.594288 1467.88341,139.594288",
  id: "Stroke-31",
  stroke: "url(#linearGradient-2)"
})));

var SvgLines = function SvgLines(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1468px",
    height: "458px",
    viewBox: "0 0 1468 458",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lines.321c70b8.svg";
export { ForwardRef as ReactComponent };